var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.candidateId)?_c('div',{staticClass:"candidate-messaging border rounded overflow-hidden"},[_c('Messaging',{attrs:{"candidate-id":_vm.candidateId,"candidate-name":_vm.candidateName,"contacts":_vm.contacts}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65df1290","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Candidate/Messaging/CandidateMessaging.vue
// module id = null
// module chunks = 